import http from '@/services/http'

export const AlvaraRenovacaoIndex = () => {
  return http.get('alvara-renovacao')
}

export const AlvaraRenovacaoStore = payload => {
  return http.post('alvara-renovacao', payload)
}

export const AlvaraRenovacaoShow = (alvaraRenovacaoId) => {
  return http.get(`alvara-renovacao/${alvaraRenovacaoId}`)
}

export const AlvaraRenovacaoUpdate = (alvaraRenovacaoId, payload) => {
  return http.put(`alvara-renovacao/${alvaraRenovacaoId}`, payload)
}

export const AlvaraRenovacaoDelete = (alvaraRenovacaoId) => {
  return http.delete(`alvara-renovacao/${alvaraRenovacaoId}`)
}

export const FinalizarAlvaraRenovacao = (alvaraRenovacaoId) => {
  return http.put(`alvara-renovacao/${alvaraRenovacaoId}/finalizar`)
}
